import { Button, Col, Container, Modal, Row } from 'react-bootstrap';

import React from 'react';
import { contentfulPropTypes } from '../../propTypes';
import withContentfulTag from '../../utils/withContentfulTag';

const RemoveCarModal = ({
  contentful,
  loading,
  fetched,
  numberPlate,
  onRemoveCar,
  onClose,
}) => {
  return (
    !loading &&
    fetched && (
      <Modal
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={!!numberPlate}>
        <Modal.Body className="pt-0">
          <Container fluid>
            <Row>
              <Col className="text-center">
                <h1 className="pt-4 pb-3">{contentful?.title}</h1>
                <p className="pb-3">
                  {contentful.subtitle}
                  <br />
                  <strong>{numberPlate}</strong>?
                </p>
                <Button
                  variant="primary"
                  onClick={() => onRemoveCar(numberPlate)}
                  className="px-5 w-100">
                  {contentful.primaryButtonText}
                </Button>
                <Button variant="link" onClick={onClose} className="pb-3 w-100">
                  {contentful.secondaryButtonText}
                </Button>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
    )
  );
};

RemoveCarModal.propTypes = {
  ...contentfulPropTypes,
};

export default withContentfulTag(RemoveCarModal, 'web_app_remove_car_modal');
